export const positions = new Float32Array([
    // 1.
    // Top Back right-top corner edges
    1.2, 1.2, 1.2,   // Start point
    1, 1.2, 1.2,   // End point

    // Top Back right-down corner edges
    1.2, 1.2, 1.2,   // Start point
    1.2, 1, 1.2,     // End point

    // Top Back right-horizontal edge
    1.2, 1.2, 1.2,    // Start point
    1.2, 1.2, 1,      // End point

    // 2.
    // Top Back left-top corner edges
    1.2, 1.2, -1.2,    // Start point
    1, 1.2, -1.2,    // End point

    // Top Back left-horizontal edge
    1.2, 1.2, -1.2,    // Start point
    1.2, 1.2, -1,      // End point
    
    // Top Back left-down corner edges
    1.2, 1.2, -1.2,    // Start point
    1.2, 1, -1.2,      // End point

    // 3.
    // Top Front left-back edge
    -1.2, 1.2, -1.2,    // Start point
    -1, 1.2, -1.2,      // End point

    // Top Front left-front edge
    -1.2, 1.2, -1.2,    // Start point
    -1.2, 1.2, -1,      // End point

    // Top Front left-down edge
    -1.2, 1.2, -1.2,    // Start point
    -1.2, 1, -1.2,      // End point

    // 4.
    // Top Front right-vertical edge
    -1.2, 1.2, 1.2,    // Start point
    -1.2, 1, 1.2,      // End point

    // Top Front right-down edge
    -1.2, 1.2, 1.2,    // Start point
    -1.2, 1.2, 1,     // End point

    // Top Front right-horizontal edge
    -1.2, 1.2, 1.2,    // Start point
    -1, 1.2, 1.2,      // End point

    // 5.
    // Top Bottom left-horizontal edge
    -1.2, -1.2, -1.2,    // Start point
    -1, -1.2, -1.2,      // End point
    
    // Top Bottom left-vertical edge
    -1.2, -1.2, -1.2,    // Start point
    -1.2, -1, -1.2,     // End point

    // Top Bottom left-down edge
    -1.2, -1.2, -1.2,    // Start point
    -1.2, -1.2, -1,      // End point

    // 6.
    // Top Bottom right-horizontal edge
    -1.2, -1.2, 1.2,    // Start point
    -1, -1.2, 1.2,      // End point

    // Top Bottom right-vertical edge
    -1.2, -1.2, 1.2,   // Start point
    -1.2, -1.2, 1,      // End point

    // Top Bottom right-down edge
    -1.2, -1.2, 1.2,   // Start point
    -1.2, -1, 1.2,      // End point

    // 7.
    // Top Bottom right-horizontal edge
    1.2, -1.2, 1.2,    // Start point
    1, -1.2, 1.2,      // End point

    // Top Bottom right-vertical edge
    1.2, -1.2, 1.2,   // Start point
    1.2, -1.2, 1,      // End point

    // Top Bottom right-down edge
    1.2, -1.2, 1.2,   // Start point
    1.2, -1, 1.2,      // End point
]);